const DTYPES = {
  DATE: "date",
  STRING: "string",
  INTEGER: "integer",
  BOOLEAN: "boolean",
};

const DATE_FILTER_TYPES = {
  EXPLICIT: "explicit",
  IMPLICIT: "implicit",
};

const DATE_FILTER_SINCE_TYPES = {
  LAST: "last",
  NEXT: "next",
};

const DATE_FILTER_SINCE_UNITS = {
  DAYS: "days",
  WEEKS: "weeks",
  MONTHS: "months",
  YEARS: "years",
};

export {
  DTYPES,
  DATE_FILTER_TYPES,
  DATE_FILTER_SINCE_TYPES,
  DATE_FILTER_SINCE_UNITS,
};
